export default __webpack_public_path__ + "static/media/RealEtext.70036109.png";